export default {"src":"/_next/static/media/mediBuddy-logo.ac62af6c.svg","height":33,"width":120,"blurWidth":0,"blurHeight":0};